export default __webpack_public_path__ + "static/media/ksztalty-niski ig-1.66161458.svg";